/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var NaturePlantTreeFirIcon24Solid = forwardRef('NaturePlantTreeFirIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M13.336 1.917a1.75 1.75 0 0 0-2.672 0l-7.208 8.52A.95.95 0 0 0 4.181 12h2.493l-4.431 5.113c-.64.738-.116 1.887.861 1.887H10.5v3.5a1.5 1.5 0 1 0 3 0V19h7.396c.977 0 1.501-1.149.861-1.887L17.326 12h2.493a.95.95 0 0 0 .725-1.564l-7.208-8.519Z" })));
});
